// Helpers puros para leer el shape de "grupo" que devuelven tanto
// listGroups (PlataformaGruposPage) como getGruposDetallePorUsuario (arbol
// de ClientePlataformaPanel) — mismos campos (id/nm/unidades_detalle/
// usuarios_detalle) en ambos casos, por eso se comparten aca en vez de
// duplicarse.
export const getGrupoId = (grupo) => grupo?.id ?? grupo?.itemId ?? grupo?.sys_id;
export const getGrupoNombre = (grupo) => grupo?.nm || grupo?.name || grupo?.nombre || "-";

export const getGrupoUnitIds = (grupo) => {
  // "u"/"units"/"unitIds" son los nombres que trae el item crudo de
  // Wialon/Leasecontrol; "unidades" es el que arma getGruposDetallePorUsuario
  // (arbol de ClientePlataformaPanel) al recortar el objeto — hace falta
  // aceptar ambos para que el editor de grupo preseleccione bien desde ahi.
  const raw = grupo?.u || grupo?.units || grupo?.unitIds || grupo?.unidades || [];
  if (!Array.isArray(raw)) return [];
  return raw
    .map((item) => {
      if (item && typeof item === "object") return item.id ?? item.itemId ?? item.sys_id;
      return item;
    })
    .filter((id) => id !== undefined && id !== null && String(id).trim() !== "");
};

export const getGrupoDescripcion = (grupo) =>
  grupo?.dsc || grupo?.description || grupo?.descripcion || grupo?.prp?.descr || "";

export const getGrupoUsuarios = (grupo) => (Array.isArray(grupo?.usuarios_detalle) ? grupo.usuarios_detalle : []);
export const getUsuarioId = (usuario) => usuario?.id || usuario?.external_user_id;
export const getUsuarioNombre = (usuario) => usuario?.nm || usuario?.name || usuario?.external_username || "-";

export const getUnidadNombre = (u) => u?.nm || u?.name || "-";
export const getUnidadUid = (u) => u?.uid || u?.uid2 || "-";
export const getUnidadId = (u) => u?.id ?? u?.itemId ?? u?.sys_id;

export const mergeById = (base = [], extra = [], getId) => {
  const map = new Map();
  [...base, ...extra].forEach((item) => {
    const id = getId(item);
    if (id !== undefined && id !== null && String(id).trim() !== "") {
      map.set(String(id), item);
    }
  });
  return [...map.values()];
};

export const toggleId = (ids = [], id) => {
  const value = String(id);
  const next = new Set(ids.map((item) => String(item)));
  if (next.has(value)) next.delete(value);
  else next.add(value);
  return [...next];
};
